import React, { PureComponent } from 'react';
import styled from 'styled-components';

const ThumbnailContainer = styled.div`
  width: 100%;
  height: 380px;
  margin-left: 0;
  padding-top:30px
  display: inline-block
`;

const Thumb = styled.img`
  height: 380px;
`;

export default class Thumbnail extends PureComponent {
  render() {
    const { url } = this.props;
    return (
      <ThumbnailContainer>
        <Thumb src={url} />
      </ThumbnailContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Thumbnail.js